angular.module('ikeweb.user').controller('ForgotPasswordController', ['$scope', 'loginService',
    function($scope, loginService) {

        $scope.user = {};
        $scope.sending = false;

        $scope.requestPasswordReset = function() {

            $scope.sending = true;
            loginService.requestPasswordReset($scope.user.email)
                .finally(function() {
                    $scope.sending = false;
                });
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/password/forgot/forgot.password.controller.js
// module id = 473
// module chunks = 0